import * as React from 'react';
import ComingSoon from '../../Upcomingpages/ComingSoon';

class TransactionsHome extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <ComingSoon />
        )
    }

}

export default TransactionsHome;